export default __webpack_public_path__ + "static/media/warning.adc138d2.svg";